<template>
  <div>
    <div class="px-4 py-2">
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100 text-center">
          <div class="card-header text-white bg-main h4">
            <div style="position: relative">
              <div class="">
                <strong>VERIFICACIÓN STOCK</strong>
              </div>
              <div
                class="btn-home-jefatura"
                style="right: 0; top: 0; position: absolute"
              >
                <button
                  type="button"
                  class="btn btn-sm px-2"
                  @click="viewHistorial"
                >
                  <i class="fa fa-table"></i> Reporte
                </button>
                &nbsp;
                <button
                  type="button"
                  class="btn btn-sm px-2"
                  @click="returnHome"
                >
                  <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
              </div>
            </div>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <!--Filtro-->
              <div class="col-md-12 py-2">
                <div class="row d-flex">
                  <div
                    class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 mt-1 mb-2"
                  >
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">ALMACÉN</span>
                      <v-select
                        class="text-dark flex-grow-1"
                        label="name"
                        :options="dataAlmacen"
                        placeholder="- Seleccionar -"
                        v-model="selectedAlma"
                        :reduce="(name) => name.id"
                        @input="mtdGetData"
                      >
                        <template slot="no-options">
                          No hay Almacen para la busqueda.
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="col-xl-5 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2"
                  >
                    <div class="card" style="padding: 5px">
                      <div class="d-flex align-items-center">
                        <span class="me-3 ms-3">Tipo</span>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterType"
                            id="inlineRadio3"
                            value="2"
                            v-model="filterType"
                            @change="mtdGetData"
                          />
                          <label class="form-check-label" for="inlineRadio3"
                            >Todos</label
                          >
                        </div>
                        <div class="form-check form-check-inline me-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterType"
                            id="inlineRadio1"
                            value="1"
                            v-model="filterType"
                            @change="mtdGetData"
                          />
                          <label class="form-check-label" for="inlineRadio1"
                            >Vencido</label
                          >
                        </div>
                        <div class="form-check form-check-inline me-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterType"
                            id="inlineRadio2"
                            value="3"
                            v-model="filterType"
                            @change="mtdGetData"
                          />
                          <label class="form-check-label" for="inlineRadio2"
                            >Por vencer</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-1 col-lg-2 col-md-6 col-sm-6 col-xs-6 mb-2 btn-home"
                  >
                    <button
                      class="btn btn-sm w-100 text-white w-100 py-2 bg-main"
                      type="button"
                      :disabled="mtddisable"
                      @click="viewpdf()"
                    >
                      <i class="fas fa-file-pdf" style="font-size: 18px"></i
                      >&nbsp; Pdf
                    </button>
                  </div>
                  <div class="col-xl-1 col-lg-2 col-md-6 col-sm-6 col-xs-6">
                    <button
                      class="btn btn-sm w-100 text-white w-100 py-2 bg-main"
                      type="button"
                      :disabled="mtddisableSave"
                      @click="saveData()"
                    >
                      <i class="fas fa-save" style="font-size: 18px"></i>&nbsp;
                      Guardar
                    </button>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="input-group input-group w-100">
                      <span class="input-group-text text-white bg-main"
                        ><i class="fas fa-search"></i
                      ></span>
                      <input
                        v-model="search"
                        type="text"
                        class="form-control form-control"
                        placeholder="NOMBRE"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2"
                  >
                    <div class="card" style="padding: 5px">
                      <div class="d-flex align-items-center">
                        <span class="me-3 ms-3">Stock</span>
                        <div class="form-check form-check-inline me-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterStock"
                            id="inlineRadioStock1"
                            value="1"
                            v-model="filterStock"
                            @change="mtdGetData"
                          />
                          <label
                            class="form-check-label"
                            for="inlineRadioStock1"
                            >Todos</label
                          >
                        </div>
                        <div class="form-check form-check-inline me-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterStock"
                            id="inlineRadioStock2"
                            value="3"
                            v-model="filterStock"
                            @change="mtdGetData"
                          />
                          <label
                            class="form-check-label"
                            for="inlineRadioStock2"
                            >Con stock</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="filterStock"
                            id="inlineRadioStock3"
                            value="2"
                            v-model="filterStock"
                            @change="mtdGetData"
                          />
                          <label
                            class="form-check-label"
                            for="inlineRadioStock3"
                            >Sin stock</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2"
                  >
                    <div v-if="showTable">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1"
                        v-if="checkDate && checkDate.length != 0"
                      >
                        <h6 style="font-size: 13px; margin-right: 3px">
                          Ultima fecha de Guardado:
                          {{ checkDate | formatDateTime }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Fin Filtro-->

              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3"
                id="content-timelinetable"
                v-if="showTable"
              >
                <table
                  id="tb-anular"
                  class="table table-bordered border-main align-middle"
                >
                  <thead>
                    <tr
                      class="text-white border-white text-center"
                      style="background: #900052; vertical-align: middle"
                    >
                      <th scope="col" class="">CODIGO</th>
                      <th scope="col">NOMBRE</th>
                      <th scope="col">MOL - COMERCIAL</th>
                      <th scope="col">PRESENT.</th>
                      <th scope="col">MARCA</th>
                      <th scope="col">LOTE</th>
                      <th scope="col">
                        FECHA VCTO
                        <i
                          class="fa fa-arrow-up flecha"
                          @click="sortData('date_vcto', 'asc')"
                        ></i>
                        <i
                          class="fa fa-arrow-down flecha"
                          @click="sortData('date_vcto', 'desc')"
                        ></i>
                      </th>
                      <th scope="col" class="">CANT. FISICA</th>
                      <th scope="col" class="">CANT. ACTUAL</th>
                      <th scope="col" class="">UBI</th>
                      <th scope="col" class="">PRE. COMPRA</th>
                      <th scope="col" class="">PRE. PARTICULAR</th>
                      <th scope="col" class="">REGISTRO SANITARIO</th>
                      <!-- <th scope="col" class="table-th-acciones">DIFERENCIA</th> -->
                    </tr>
                  </thead>

                  <tbody class="custom-table">
                    <tr v-if="cpData.length == 0">
                      <td class="text-center align-middle" colspan="6">
                        Sin inventario
                      </td>
                    </tr>
                    <tr v-for="(movement, index) in dataShow" :key="index">
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.code"
                          placeholder="Ingrese codigo."
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.subsubcategoria }}
                      </td>
                      <td
                        class="text-center align-middle"
                        @dblclick="mtdGetDataID(movement.id, index)"
                      >
                        {{ movement.product }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.presentation }}
                      </td>
                      <td class="text-center align-middle">
                        <v-select
                        
                          id="brand"
                          class="text-dark"
                          label="name"
                          :options="dataMarca"
                          placeholder="- Buscar Marca (Escriba uno...) -"
                          @search="searchmarca"
                          v-model="movement.brand"
                          :reduce="(name) => name.id"
                          required
                          :clearable="false"
                        >
                          <template slot=" no-options">
                            No hay Productos para la busqueda.
                          </template>
                        </v-select>
                      </td>
                      <!-- <td class="text-center align-middle">
                        {{ movement.lote ? movement.lote.toUpperCase() : "-" }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.date_vcto | formatDate }}
                      </td> -->
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.lote"
                          placeholder="Ingrese lote."
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="date"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.date_vcto"
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.quantity }}
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.quantity_fisica"
                          @keydown="filterKey"
                          placeholder="Ingrese Cant."
                          @input="validateInput(movement)"
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.ubicacion"
                          placeholder="Ubicacion"
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.purchase"
                          placeholder="Ingrese Cant."
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.particular"
                          placeholder="Ingrese Cant."
                          @input="validateInput(movement)"
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <td class="text-center align-middle">
                        <input
                          type="text"
                          class="input-p form-control form-control-sm text-center"
                          v-model="movement.registro"
                          placeholder="Ingrese registro."
                          style="font-size: 10px; padding: 0.25rem 0.5rem"
                        />
                      </td>
                      <!-- <td class="text-center align-middle">
                        {{ movement.diferencia }}
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 text-center"
              >
                <!-- paginado -->
                <div
                  v-if="cpData.length > 0 && showTable"
                  class="d-flex justify-content-center mb-2"
                >
                  <nav aria-label="Page navigation example">
                    <ul class="pagination mb-1">
                      <li class="page-item">
                        <a
                          class="page-link page"
                          href="javascript:void(0)"
                          @click="backPage"
                          >Anterior</a
                        >
                      </li>
                      <li
                        v-if="limitedStepPagination[0] != 1"
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage == 1 ? 'page-link active' : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(1)"
                          >1</a
                        >
                      </li>
                      <li
                        v-if="limitedStepPagination[0] > 2"
                        class="page-item disabled"
                      >
                        <span class="page-link">...</span>
                      </li>

                      <li
                        v-for="(item, index) in limitedStepPagination"
                        :key="index"
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage == item
                              ? 'page-link active'
                              : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(item)"
                          >{{ item }}
                        </a>
                      </li>
                      <li
                        v-if="
                          limitedStepPagination[
                            limitedStepPagination.length - 1
                          ] <
                          stepPagination.length - 1
                        "
                        class="page-item disabled"
                      >
                        <span class="page-link">...</span>
                      </li>
                      <li
                        v-if="
                          limitedStepPagination[
                            limitedStepPagination.length - 1
                          ] != stepPagination.length
                        "
                        class="page-item"
                      >
                        <a
                          :class="
                            selectPage == limitedStepPagination.length + 2
                              ? 'page-link active'
                              : 'page-link'
                          "
                          href="javascript:void(0)"
                          @click="selectedPage(stepPagination.length)"
                          >{{ stepPagination.length }}
                        </a>
                      </li>
                      <li class="page-item">
                        <a
                          class="page-link page"
                          href="javascript:void(0)"
                          @click="nextPage"
                          >Siguiente</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
    <cModalAddMedicine
      :accion="accion"
      @closeModal="mtdHideModal"
      :clasificacion="clasificacion"
      :brand="brand"
      :subsector="subsector"
      :sector="sector"
      :contracts="contracts"
      :subsubcategoryObject="Subsubcategory"
      :title="modal.title"
      :boo_modal="modal.modal_form"
      :action="modal.action"
      @mtdAddBrand="mtdAddBrand"
      @mtdAddSubsector="mtdAddSubsector"
      @mtdAddSector="mtdAddSector"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalAddMedicine from "../../Maintenance/Modals/cModalAddMedicine.vue";

export default {
  name: "Inventary",
  components: {
    SweetAlert,
    cModalAddMedicine,
  },
  data() {
    return {
      swal: null,
      search: "",
      dataShow: [],
      showTable: false,
      dataIn: [],
      items: 10,
      checkDate: [],
      dataAlmacen: [],
      selectedAlma: null,
      filter: {
        init: null,
        end: null,
      },
      filterType: 2,
      filterStock: 1,
      sortDirection: null,
      sortKey: null,
      excelData: [],
      //Pag
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
      action: "",
      // Estado de orden
      sortKey: "",
      sortOrder: "",
      variableSave: 0,
      /** editar */
      clasificacion: [],
      Subsubcategory: {
        name: "",
        Id: "",
        state: "",
        categorie_id: "",
        subcategorie_id: "",
        specialty_id: "",
        insurance_contrat_id: "",
        kairos: "",
        unidad: 0,
        particular: 0,
        eps: false,
        parti: false,
        molecule: "",
        commercial: "",
        brand: "",
        brand_id: "",
        presentation: "",
        concentration: "",
        format: "",
        stock: 0,
        minimum_stock: 0,
        state: "",
        sub_sub_category_id: null,
        provider_id: null,
        provider_id_2: null,
        sector_id: "",
        sector_name: "",
        location: "",
      },
      brand: {},
      sector: {},
      subsector: {},
      contracts: [],
      modal: {
        title: "",
        action: "",
        modal_form: false,
      },
      modalAddBrand: {
        title: "",
        action: "",
        modal_form: false,
        num: 0,
        payload: {},
      },
      modalAddSector: {
        title: "",
        action: "",
        modal_form: false,
        num: 0,
        payload: {},
      },
      modalAddSubsector: {
        title: "",
        num: 0,
        modal_form: false,
        payload: {},
      },
      accion: 0,
      posEdit: null,
      brands: [],
      dataMarca: [],
    };
  },
  watch: {
    selectedAlma(newVal) {
      if (newVal == null) {
        this.dataIn = [];
        this.showTable = false;
      }
    },
    selectPage() {
      this.calculateData(10);
    },
    search() {
      this.selectPage = 1;
      this.calculateData(10);
    },
    filterType() {
      this.selectPage = 1;
    },
    filterStock() {
      this.selectPage = 1;
    },
  },
  computed: {
    mtddisable() {
      return !(
        this.selectedAlma != null &&
        this.filter.end != null &&
        this.variableSave != 0
      );
    },
    mtddisableSave() {
      return !(this.variableSave != 0);
    },
    cpData() {
      let data = [...this.dataIn];

      if (this.search.length >= 3) {
        const query = this.search.toUpperCase();
        data = data.filter((el) => {
          return (el.subsubcategoria || "").toUpperCase().includes(query);
        });
      }

      return data;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  created() {
    moment.locale("es");
    this.filter.end =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
    this.filter.init = this.filter.end;

    this.vercampus();
    this.mtdGetSave();
    this.filterStock = 1;
    this.mtdClasificacion();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function () {
      if (this.selectedAlma == null) {
        this.$refs.SweetAlert.showWarning("Seleccione un Almacén");
      } else {
        this.post({
          url: this.$store.getters.get__url + "/Inventario/verificacion",
          token: this.$store.getters.get__token,
          params: {
            alma: this.selectedAlma,
            filterType: this.filterType,
            filterStock: parseInt(this.filterStock),
          },
        })
          .then((response) => {
            this.dataIn = response.data;
            if (this.dataIn.length == 0) {
              this.showTable = false;
              this.variableSave = 0;
              this.$refs.SweetAlert.showWarning("Sin Datos");
            } else {
              this.showTable = true;
              this.variableSave = 1;
              this.calculateData(10);
              this.setDiferenciaToQuantity();
            }
          })
          .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
          });
      }
    },
    mtdGetSave: function () {
      this.get({
        url: this.$store.getters.get__url + "/Inventario/traerSave",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.checkDate = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    paginatedData() {
      const start = (this.selectPage - 1) * this.items;
      const end = start + this.items;
      return this.filteredData.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.items);
    },
    calculateData(items) {
      const data = this.cpData;

      const totalPages = Math.ceil(data.length / items);
      this.stepPagination = Array.from({ length: totalPages }, (_, i) => i + 1);

      const start = (this.selectPage - 1) * items;
      const end = start + items;

      this.dataShow = data.slice(start, end);
    },
    sortData(key, order) {
      if (this.sortKey && this.sortKey != key) {
        this.sortOrder = "";
      }
      this.sortKey = key;
      this.sortOrder = order;

      this.dataIn.sort((a, b) => {
        let result = 0;

        // Convertir valores a números si la clave es 'price_unit' o 'valorizado'
        const valueA =
          key == "price_unit" || key == "valorizado"
            ? parseFloat(a[key])
            : a[key];
        const valueB =
          key == "price_unit" || key == "valorizado"
            ? parseFloat(b[key])
            : b[key];

        if (valueA < valueB) result = -1;
        if (valueA > valueB) result = 1;

        return order == "asc" ? result : -result;
      });
      this.calculateData(10);
    },
    setDiferenciaToQuantity() {
      Object.values(this.dataIn).forEach((movement) => {
        movement.diferencia = parseFloat(movement.quantity);
      });
    },
    clearData() {
      this.dataIn = [];
      this.showTable = false;
    },
    viewpdf: function () {
      let filterType = "todos";
      /* if (this.filterType.includes("1") && this.filterType.includes("2")) {
                filterType = 'todos';
            } else if (this.filterType.includes("1")) {
                filterType = 'vencidos';
            } else if (this.filterType.includes("2")) {
                filterType = 'por_vencer';
            } */
      if (this.filterType == 2) {
        filterType = "todos";
      } else if (this.filterType == 1) {
        filterType = "vencidos";
      } else if (this.filterType == 3) {
        filterType = "por_vencer";
      }
      window.open(
        this.$store.getters.get__url +
          "/viewpdfVerificacion/" +
          this.selectedAlma +
          "/" +
          filterType,
        "_blank"
      );
    },
    vercampus: function () {
      this.filter.campus_id = this.$store.getters.get__campus;
      this.get({
        url:
          this.$store.getters.get__url +
          "/Kardex/filterAlmacen/" +
          this.filter.campus_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataAlmacen = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    filterKey: function (e) {
      let b = false;
      b = /^[0-9]+$/.test(e.key);
      if (b == false && e.key != "Backspace") {
        e.preventDefault();
      }
    },
    filterKey: function (e) {
      if (e.key == "Tab") {
        return;
      }
      let isNumber = /^[0-9]+$/.test(e.key);
      if (!isNumber && e.key != "Backspace") {
        e.preventDefault();
      }
    },
    validateInput: function (movement) {
      const quantity = parseFloat(movement.quantity);
      const quantity_fisica = parseFloat(movement.quantity_fisica) || 0;
      movement.diferencia = quantity - quantity_fisica;
    },
    saveData: function () {
      let filterType = "todos";
      if (this.filterType == 2) {
        filterType = "todos";
      } else if (this.filterType == 1) {
        filterType = "vencidos";
      } else if (this.filterType == 3) {
        filterType = "por_vencer";
      }
      let dataToSave = this.dataIn.map((movement) => {
        return {
          ...movement,
          quantity_fisica: movement.quantity_fisica
            ? parseFloat(movement.quantity_fisica)
            : null,
        };
      });
      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Estás seguro de Guardar estos Datos?",
        "warning",
        "Guardar"
      ).then((result) => {
        if (result.value) {
          this.post({
            url: this.$store.getters.get__url + "/Inventario/saveStock",
            token: this.$store.getters.get__token,
            params: {
              alma: this.selectedAlma,
              data: dataToSave.filter((item) => item.quantity_fisica != null),
            },
          })
            .then((response) => {
              if (response.data.state == 0) {
                this.$refs.SweetAlert.showSuccess("Guardado Correctamente");
                this.mtdGetSave();
                this.savePdf(
                  response.data.data.stock_check_id,
                  this.selectedAlma,
                  filterType
                );
                // Limpiar todos los valores de quantity_fisica
                this.dataIn.forEach((movement) => {
                  movement.quantity_fisica = "";
                });
                this.mtdGetData();
                this.setDiferenciaToQuantity();
              } else {
                this.$refs.SweetAlert.showError(errors);
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });
        }
      });
    },
    savePdf: function (id, alma, type) {
      window.open(
        this.$store.getters.get__url +
          "/viewpdfVerStock/" +
          id +
          "/" +
          alma +
          "/" +
          type,
        "_blank"
      );
    },
    /** editar medicina */
    mtdHideModal: function (name, id) {
      this.modal = {
        title: "",
        action: "",
        modal_form: false,
      };
      this.Subsubcategory = {
        name: "",
        Id: "",
        state: "",
        categorie_id: "",
        subcategorie_id: "",
        specialty_id: "",
        insurance_contrat_id: "",
        kairos: 0.0,
        unidad: 0,
        particular: 0.0,
        eps: 0,
        parti: 0,
        molecule: "",
        commercial: "",
        brand: "",
        brand_id: "",
        presentation: "",
        concentration: "",
        format: "",
        stock: 0,
        minimum_stock: 0,
        state: "",
        sub_sub_category_id: null,
        sector: "",
        sector_id: "",
        location: "",
      };
      this.posEdit = null;
      this.brand = {};
      this.sector = {};
      this.fileLoaded = false;
      this.categorie_control = "";
      this.subcategorie_control = "";
      this.filter.name = name;
      this.filter.type = id;
      this.mtdGetData();
    },
    mtdAddBrand() {
      this.modalAddBrand = {
        title: "REGISTRAR MARCA",
        num: 0,
        modal_form: true,
        payload: {},
      };
      this.modal.modal_form = false;
    },
    mtdAddSubsector() {
      this.modalAddSubsector = {
        title: "REGISTRAR SUB-SECTOR",
        num: 0,
        modal_form: true,
        payload: {},
      };
      this.mtdGetSector();
      this.modal.modal_form = false;
    },
    mtdAddSector() {
      this.modalAddSector = {
        title: "REGISTRAR SECTOR",
        num: 0,
        modal_form: true,
        payload: {},
      };
      this.modal.modal_form = false;
    },
    mtdGetDataID: function (id, pos) {
      this.get({
        url: this.$store.getters.get__url + "/Medicament/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.Subsubcategory = response.data;
          this.subcategorie_control = response.data.subcategorie_name;
          this.mtdModalShow("edit", pos);
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    mtdModalShow: function (action, pos) {
      (this.accion = action == "store" ? 0 : 1),
        (this.modal.title =
          action == "store" ? "Nuevo Medicamento" : "Editar Medicamento");
      this.modal.action = action;
      this.modal.modal_form = true;
      this.posEdit = pos;
    },
    mtdClasificacion() {
      this.get({
        url: this.$store.getters.get__url + "/ProductDetailClassification",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.clasificacion = response.data;
          }
        })
        .catch((error) => {
          this.$refs.SweetAlert.showError(error);
        });
    },
    //Paginacion
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    viewHistorial: function () {
      this.$emit("mtdChangePage", "repVerificacion");
    },
    searchmarca: function (search, loading) {
      if (search.length >= 2) {
        this.dataMarca = [];
        loading(true);
        this.get({
          url: this.$store.getters.get__url + "/logistics/indexbrand/" + search,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            this.dataMarca = response.data;
            loading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null
        ? moment(dateTime).format("DD/MM/YYYY HH:mm")
        : "-";
    },
  },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
  font-size: 11px;
}

.large-text {
  font-size: 9px;
}

.nowrap {
  white-space: nowrap;
}

.flecha {
  font-size: 12px;
  cursor: pointer;
  margin-left: 4px;
  margin-right: 1px;
  color: #edeaec;
}
</style>